export default "__VITE_ASSET__jdC5kRMr__"